import { ComponentType, ElementType, ReactNode } from "react";
import { IconType } from "react-icons";
import {
    FaUsers,
    FaBook,
    FaBuilding,
    FaDoorOpen,
    FaFileAlt,
    FaPencilAlt,
    FaFile,
    FaChartBar,
    FaCogs,
    FaSpellCheck,
    FaChalkboardTeacher,
    FaClipboardCheck,
    FaCalculator,
    FaChartLine,
    FaUserFriends
} from "react-icons/fa";

import {
    DanhSachThiSinhLopPage,
    DanhSachThiSinhPage,
    DongTuiLapPhachPage,
    DotTuyenSinhPage,
    GanMonHocPage,
    LopHocPage,
    NhapDiemTheoLopPage,
    NganhTuyenSinhPage,
    ToChucThiPhongPage,
    TongHopDanhSachThiSinhDuKienPage,
    TongHopDiemPage
} from "../pages";

import LoaiNganhPage from "../pages/xet-tuyen-thac-sy/loai-nganh";
import MonHocPage from "../pages/xet-tuyen-thac-sy/mon-hoc/MonHocPage";
import DotHocPage from "../pages/xet-tuyen-thac-sy/dot-hoc/DotHocPage";
import HomePage from "../pages/home";
import ThamSoPage from "../pages/xet-tuyen-thac-sy/tham-so-he-thong/ThamSoPage";

export type RouteProps = {
    path: string | null | undefined;
    name: string;
    permission?: string;
    icon?: IconType | ReactNode | ComponentType | JSX.Element | any;
    children?: RouteProps[];
    component?: ComponentType<any>;
    showInMenu?: boolean;
};

const routes: RouteProps[] = [
    {
        path: undefined,
        name: "Dashboard",
        icon: FaChartLine,
        showInMenu: true,
        children: [
            {
                path: "/Dashboard",
                name: "Dashboard",
                component: HomePage,
                icon: FaChartLine,
                showInMenu: true
            }
        ]
    },

    {
        path: undefined,
        name: "Tuyển sinh",
        icon: FaSpellCheck,
        showInMenu: true,
        children: [
            {
                path: "/danh-sach-thi-sinh",
                name: "Danh sách học viên",
                component: DanhSachThiSinhPage,
                icon: FaUserFriends,
                showInMenu: true
            },
            {
                path: "/thong-ke-danh-sach-du-kien-hoc-bskt",
                name: "Thống kê học viên dự kiến",
                component: TongHopDanhSachThiSinhDuKienPage,
                icon: FaFileAlt,
                showInMenu: true
            },
        ]
    },
    {
        path: undefined,
        name: "Lớp",
        icon: FaChalkboardTeacher,
        showInMenu: true,
        children: [
            {
                path: "/danh-sach-lop",
                name: "Lịch học - thi bổ sung kiến thức",
                component: LopHocPage,
                icon: FaBuilding,
                showInMenu: true
            },
            {
                path: "/danh-sach-thi-sinh-theo-lop",
                name: "Danh sách thí sinh",
                component: DanhSachThiSinhLopPage,
                icon: FaUsers,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Điểm",
        icon: FaCalculator,
        showInMenu: true,
        children: [
            {
                path: "/nhap-diem-theo-lop",
                name: "Nhập điểm theo lớp",
                component: NhapDiemTheoLopPage,
                icon: FaPencilAlt,
                showInMenu: true
            },
            {
                path: "/tong-hop-diem",
                name: "Tổng hợp điểm",
                component: TongHopDiemPage,
                icon: FaChartBar,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Thiết lập",
        icon: FaCogs,
        showInMenu: true,
        children: [
            {
                path: "/thiet-lap-nganh",
                name: "Thiết lập ngành - môn học tuyển sinh",
                component: NganhTuyenSinhPage,
                icon: FaBuilding,
                showInMenu: true
            },
            {
                path: "/mon-hoc",
                name: "Danh mục môn học",
                component: MonHocPage,
                icon: FaBook,
                showInMenu: true
            },
            {
                path: "/dot-hoc",
                name: "Thiết lập đợt học",
                component: DotHocPage,
                icon: FaBook,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Tổ chức thi",
        icon: FaClipboardCheck,
        showInMenu: false,
        children: [
            {
                path: "/to-chuc-thi-phong",
                name: "Tổ chức thi phòng",
                component: ToChucThiPhongPage,
                icon: FaDoorOpen,
                showInMenu: true
            },
            {
                path: "/dong-tui-lap-phach",
                name: "Đóng túi lập phách",
                component: DongTuiLapPhachPage,
                icon: FaFile,
                showInMenu: true
            }
        ]
    },
    {
        path: undefined,
        name: "Thiết lập (ẩn)",
        icon: null,
        showInMenu: false,
        children: [
            {
                path: "/thiet-lap-loai-nganh",
                name: "Thiết lập loại ngành",
                component: LoaiNganhPage,
                icon: FaBuilding,
                showInMenu: false
            },
            {
                path: "/thiet-lap-tham-so",
                name: "Thiết lập tham số",
                component: ThamSoPage,
                icon: FaBuilding,
                showInMenu: false
            },
            {
                path: "/xet-tuyen-thac-sy/gan-mon-hoc",
                name: "Gán môn học",
                component: GanMonHocPage,
                icon: FaBook,
                showInMenu: false
            }
        ]
    }
];

export default routes;